import { Controls } from '../features/controls/Controls';
import { CountryList } from '../features/countries/CountryList';

export const HomePage = () => {
    return (
        <>
            <Controls />
            <CountryList />
        </>
    );
};
